<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-08-01 
-->
<template>
  <div class="main-container">
    <page-header>{{'新闻资讯' | dealLanguage('News')}}</page-header>
    <div class="warp">
      <div class="news">
        <news-item v-for="item,index in list" :key="index" :itemDetail="item"></news-item>
      </div>
      <div class="loading-warpper" v-if="loading">
        <van-loading size="20px">{{'加载中...' | dealLanguage('Loading')}}</van-loading>
      </div>
      <!-- <div class="list-over" v-if="!isMore && !loading && list.length > 0">{{'已经到底了~' | dealLanguage('No more content to load.')}}</div> -->
      <nothing v-if="!isMore && !loading && list.length == 0" :title="language == 'zh' ? '暂无相关资讯' : 'No relevant information'">
        <router-link :to="{name: 'index'}" class="btn">{{'返回首页' | dealLanguage('Back to Home')}}</router-link>
      </nothing>
      <div ref="indexlist-bottom"></div>
    </div>
  </div>
</template>
<script>
import Nothing from '@/components/common/nothing.vue'
import { getActAppMi } from '@/service/vbef'
import PageHeader from '@/components/mobile/pageHeader.vue'
import NewsItem from '@/components/index/newsItem.vue'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '新闻资讯' : 'News',
    }
  },
  inject: ['wxShare'],
  components: {
    Nothing,
    PageHeader,
    NewsItem,
  },
  created() {
    this.moduleId = this.$route.query.type || 1
    this.getList()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('新闻资讯-CSGCT', 'News-CSGCT'),
      linkurl: this.vbef_path + '/newsList',
      
    })
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      page: 1,
      list: [],
      loading: false,
      isMore: false,
      moduleId: 1
    }
  },
  computed: {
    ...mapState({
      activityId: (state) => state.activityId,
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
    }),
  },
  methods: {
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight

      const listbox = this.$refs['indexlist-bottom']
      const listrect = listbox.getBoundingClientRect()
      const listabsoluteTop = listrect.top + scrollTop
      if (
        scrollTop + windowHeight >= listabsoluteTop &&
        scrollTop > 0 &&
        !this.loading &&
        this.isMore
      ) {
        this.getMore()
      }
    },
    async getList() {
      this.loading = true
      let res = await getActAppMi({
        page: this.page,
        size: 12,
        activityId: this.activityId,
        isEnglish: this.language == 'en' ? 1 : 0,
        moduleId: this.moduleId
      })
      this.loading = false
      if (res.code == 0) {
        this.list = [...this.list, ...res.data]
        this.isMore = res.data.length == 12
      }
    },
    getMore() {
      this.page++
      this.getList()
    },
  },
  watch: {
    '$route.query.type'(val) {
      this.moduleId = val || 1
      this.page = 1
      this.list = []
      this.getList()
    }
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
.warp
  padding 0.2rem 0.4rem 0.4rem
.news
  display grid
  grid-template-columns repeat(2, 1fr)
  grid-gap 0.3rem 0.3rem
  & > :nth-child(2n+1)
    justify-self end
  & > :nth-child(2n)
    justify-self start
  >>> .news-item
    width 100%
    max-width 4rem
    min-width auto
    box-shadow 0px 0.06rem 0.16rem 0 rgba(0, 0, 0, 0.1)
    .news-img
      height calc(28.13vw - 0.31rem)
      max-height 2.25rem
    .news-content
      padding 0.2rem
      .title
        font-size 0.24rem
        line-height 0.36rem
      .time
        font-size 0.22rem
        line-height 0.22rem
        margin-top 0.2rem
</style>